import i18n from '~lib/i18n';

interface ReservationTypeValue {
	bookingTypes?: string[];
	reservationType?: string;
}

// The `fixed` option is the odd one out: its description lives under a
// `reservation` key, while the other three share a name with their title key.
const descriptionKeys = {
	fixed: 'reservation',
	flexible: 'flexible',
	scanOnly: 'scanOnly',
	nonBookable: 'nonBookable',
};

export const getReservationTypeSlug = (value: ReservationTypeValue) => {
	const [bookingTypes] = value.bookingTypes ?? [];
	const reservationType = value.reservationType;

	if (bookingTypes === 'regular' && reservationType === 'fixed') {
		return 'fixed';
	} else if (bookingTypes === 'scanQr' && reservationType === 'fixed') {
		return 'flexible';
	} else if (bookingTypes === 'scanNfc' && reservationType === 'flexible') {
		return 'scanOnly';
	} else if (bookingTypes === 'scanQr' && reservationType === 'nonBookable') {
		return 'nonBookable';
	} else {
		return null;
	}
};

export const handleReservationType = (value: ReservationTypeValue) => {
	const slug = getReservationTypeSlug(value);

	if (!slug) {
		return 'UPDATE Usage type';
	}

	return i18n.t(`views.addItem.bookingType.options.${slug}.title`);
};

export const handleReservationTypeDescription = (value: ReservationTypeValue, fallback = '') => {
	const slug = getReservationTypeSlug(value);

	if (!slug) {
		return fallback;
	}

	return i18n.t(`views.addItem.bookingType.options.${descriptionKeys[slug]}.description`, {
		defaultValue: fallback,
	});
};
